import { useMutation } from '@tanstack/react-query';
import { clientService, UpdateClientPayload } from '@services/client';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import {
  getErrorMessage,
  isClientEmailAlreadyMemberError,
  isClientEmailAlreadyLinkedError,
} from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useEditClient = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['client'],
    mutationFn: async (payload: UpdateClientPayload) => {
      return await clientService.updateClient(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
      toast.success(tActionMessages.clientUpdatedSuccessfully);
    },
    onError: (error: any) => {
      // Sprint 25, story-128 (run 5). Same refuse-whole-update cases as create — shown inline
      // under Email by CreateEditClientModal, not as a toast.
      if (isClientEmailAlreadyMemberError(error) || isClientEmailAlreadyLinkedError(error)) {
        return;
      }
      toast.error(getErrorMessage(error, tActionMessages.requestError));
    },
  });
};

export default useEditClient;
